import { useState, useEffect } from "react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [analytics, setAnalytics] = useState(true);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("securycles_cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem(
      "securycles_cookie_consent",
      JSON.stringify({ analytics: true, marketing: true, essential: true })
    );
    setVisible(false);
  };

  const savePreferences = () => {
    localStorage.setItem(
      "securycles_cookie_consent",
      JSON.stringify({ analytics, marketing, essential: true })
    );
    setVisible(false);
  };

  const rejectAll = () => {
    localStorage.setItem(
      "securycles_cookie_consent",
      JSON.stringify({ analytics: false, marketing: false, essential: true })
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 md:p-6">
      <div className="max-w-4xl mx-auto bg-black text-white rounded-2xl shadow-2xl overflow-hidden">
        <div className="p-5 md:p-6">
          <div className="flex items-start gap-3 mb-4">
            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
              <i className="ri-shield-check-line text-[#FFB100] text-xl"></i>
            </div>
            <div>
              <h3 className="font-bold text-base mb-1">Gestion des cookies</h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                Nous utilisons des cookies pour améliorer votre expérience sur notre site de serrurier à Créteil. Les cookies essentiels sont nécessaires au fonctionnement du site.{" "}
                <a href="/mentions-legales" className="text-[#FFB100] underline hover:no-underline">
                  En savoir plus
                </a>
              </p>
            </div>
          </div>

          {showDetails && (
            <div className="mb-4 space-y-3 border-t border-gray-700 pt-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium">Cookies essentiels</p>
                  <p className="text-xs text-gray-400">Nécessaires au fonctionnement du site</p>
                </div>
                <div className="w-10 h-5 bg-[#FFB100] rounded-full flex items-center justify-end px-1 cursor-not-allowed">
                  <div className="w-3 h-3 bg-black rounded-full"></div>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium">Cookies analytiques</p>
                  <p className="text-xs text-gray-400">Mesure d'audience anonymisée</p>
                </div>
                <button
                  onClick={() => setAnalytics(!analytics)}
                  className={`w-10 h-5 rounded-full flex items-center px-1 transition-colors cursor-pointer ${
                    analytics ? "bg-[#FFB100] justify-end" : "bg-gray-600 justify-start"
                  }`}
                >
                  <div className={`w-3 h-3 rounded-full ${analytics ? "bg-black" : "bg-white"}`}></div>
                </button>
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium">Cookies marketing</p>
                  <p className="text-xs text-gray-400">Publicités personnalisées</p>
                </div>
                <button
                  onClick={() => setMarketing(!marketing)}
                  className={`w-10 h-5 rounded-full flex items-center px-1 transition-colors cursor-pointer ${
                    marketing ? "bg-[#FFB100] justify-end" : "bg-gray-600 justify-start"
                  }`}
                >
                  <div className={`w-3 h-3 rounded-full ${marketing ? "bg-black" : "bg-white"}`}></div>
                </button>
              </div>
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-2">
            <button
              onClick={acceptAll}
              className="flex-1 bg-[#FFB100] text-black font-bold py-2.5 rounded-full text-sm hover:bg-yellow-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              Tout accepter
            </button>
            <button
              onClick={() => setShowDetails(!showDetails)}
              className="flex-1 border border-gray-600 text-white py-2.5 rounded-full text-sm hover:border-[#FFB100] hover:text-[#FFB100] transition-colors cursor-pointer whitespace-nowrap"
            >
              {showDetails ? "Masquer les détails" : "Personnaliser"}
            </button>
            {showDetails ? (
              <button
                onClick={savePreferences}
                className="flex-1 border border-[#FFB100] text-[#FFB100] py-2.5 rounded-full text-sm hover:bg-[#FFB100] hover:text-black transition-colors cursor-pointer whitespace-nowrap"
              >
                Enregistrer
              </button>
            ) : (
              <button
                onClick={rejectAll}
                className="flex-1 border border-gray-600 text-gray-400 py-2.5 rounded-full text-sm hover:border-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                Refuser
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
